import { BlockDefinition } from "@softr-io/blocks-sdk";
import { useCallback, useSyncExternalStore } from "react";
import { isPreCompiledBlock } from "./PreCompiledBlockDefinition";

export function useBlockReadiness() {
    const manifestLoaded = useSyncExternalStore(subscribeToManifestLoaded, getManifestLoadedSnapshot);
    const blockLoaded = useSyncExternalStore(subscribeToBlockLoaded, getBlockLoadedSnapshot);

    const isBlockReady = useCallback(
        (def: BlockDefinition): boolean => {
            if (isPreCompiledBlock(def)) {
                return true;
            }
            return (
                !!manifestLoaded[`name:${def.name}/version:${def.version}`] &&
                !!blockLoaded[`name:${def.name}/version:${def.version}`]
            );
        },
        [manifestLoaded, blockLoaded],
    );

    return { isBlockReady };
}
export function isBlockReady(def: BlockDefinition) {
    const manifestLoaded = getManifestLoadedSnapshot();
    const blockLoaded = getBlockLoadedSnapshot();
    if (isPreCompiledBlock(def)) {
        return true;
    }
    return (
        !!manifestLoaded[`name:${def.name}/version:${def.version}`] &&
        !!blockLoaded[`name:${def.name}/version:${def.version}`]
    );
}

type Key = `name:${string}/version:${string}`;
let MANIFEST_LOADED_MAP: Record<Key, boolean> = {};
export function onManifestLoaded({ name, version }: { name: string; version: string }) {
    MANIFEST_LOADED_MAP = {
        ...MANIFEST_LOADED_MAP,
        [`name:${name}/version:${version}`]: true,
    };
    // Dispatch the event async so that any error in the handler doesn't reject the promise which calls this
    setTimeout(() => {
        window.dispatchEvent(new CustomEvent("@softr/manifest-load-map-updated", { detail: { name, version } }));
    });
}
export function onBlockLoadError({ name, version }: { name: string; version: string }) {
    MANIFEST_LOADED_MAP = {
        ...MANIFEST_LOADED_MAP,
        [`name:${name}/version:${version}`]: true,
    };
    BLOCK_LOADED_MAP = {
        ...BLOCK_LOADED_MAP,
        [`name:${name}/version:${version}`]: true,
    };
    // Dispatch the event async so that any error in the handler doesn't reject the promise which calls this
    setTimeout(() => {
        window.dispatchEvent(new CustomEvent("@softr/manifest-load-map-updated", { detail: { name, version } }));
    });
    setTimeout(() => {
        window.dispatchEvent(new CustomEvent("@softr/block-component-load-map-updated", { detail: { name, version } }));
    });
}
function subscribeToManifestLoaded(onManifestLoadMapUpdated: () => void) {
    window.addEventListener("@softr/manifest-load-map-updated", onManifestLoadMapUpdated);

    return () => window.removeEventListener("@softr/manifest-load-map-updated", onManifestLoadMapUpdated);
}
function getManifestLoadedSnapshot() {
    return MANIFEST_LOADED_MAP;
}

let BLOCK_LOADED_MAP: Record<Key, boolean> = {};
export function onBlockComponentLoaded({ name, version }: { name: string; version: string }) {
    BLOCK_LOADED_MAP = {
        ...BLOCK_LOADED_MAP,
        [`name:${name}/version:${version}`]: true,
    };

    // Dispatch the event async so that any error in the handler doesn't reject the promise which calls this
    setTimeout(() => {
        window.dispatchEvent(new CustomEvent("@softr/block-component-load-map-updated", { detail: { name, version } }));
    });
}
function subscribeToBlockLoaded(onBlockComponentLoadMapUpdated: () => void) {
    window.addEventListener("@softr/block-component-load-map-updated", onBlockComponentLoadMapUpdated);
    return () => window.removeEventListener("@softr/block-component-load-map-updated", onBlockComponentLoadMapUpdated);
}
function getBlockLoadedSnapshot() {
    return BLOCK_LOADED_MAP;
}
